import {AbstractEvent} from "@/modules/base/events";
import {Match} from "@/modules/match/entity";
import {Competition} from "@/modules/competitions/entity";

export class BeforeMatchEvent extends AbstractEvent {
  constructor(
    public match: Match,
    public competition: Competition,
  ) {
    super();
  }
}